export const searchOptions = [
  { label: "Problem Name", value: "problemName" },
  { label: "Content", value: "content" }
];

export const orderByColumnNames = [
  { label: "Reply Count Asc", value: "repliesCountAsc" },
  { label: "Reply Count Desc", value: "repliesCountDesc" },
  { label: "Like Count Asc", value: "likesCountAsc" },
  { label: "Like Count Desc", value: "likesCountDesc" },
  { label: "Created At Asc", value: "createdAtAsc" },
  { label: "Created At Desc", value: "createdAtDesc" }
];
